(function () {
  'use strict';
  var U = window.URBANHAAT || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function group(n, d) {
    var s = n.toFixed(d).split('.');
    s[0] = s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    return s.join('.');
  }
  function money(cents) {
    var f = U.moneyFormat || '₹{{amount_no_decimals}}';
    var v = cents / 100;
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return group(v, 0);
      if (k === 'amount_with_comma_separator') return group(v, 2).replace(/,/g, '|').replace('.', ',').replace(/\|/g, '.');
      if (k === 'amount_no_decimals_with_comma_separator') return group(v, 0).replace(/,/g, '.');
      var t = group(v, 2);
      return t.replace(/\.00$/, '');
    });
  }

  /* ---------- cart drawer ---------- */
  var drawer = $('#CartDrawer');
  var onCartPage = document.body.classList.contains('template-cart');
  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    var c = $('[data-cart-close]', drawer.querySelector('.cart-drawer__panel'));
    if (c) c.focus();
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
  }
  function renderCart(sections) {
    if (!sections || !sections['cart-drawer']) return;
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var fresh = $('.cart-drawer__inner', doc);
    var old = $('.cart-drawer__inner', drawer);
    if (fresh && old) {
      old.replaceWith(fresh);
      var n = parseInt(fresh.getAttribute('data-count'), 10) || 0;
      $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
    }
  }
  function post(url, body) {
    body.sections = 'cart-drawer';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { j.__ok = r.ok; return j; }); });
  }
  function addToCart(body) {
    return post(U.cartAdd, body).then(function (j) {
      if (!j.__ok) throw new Error(j.description || j.message || 'Could not add to bag');
      renderCart(j.sections);
      openCart();
    });
  }
  function changeLine(line, qty) {
    post(U.cartChange, { line: line, quantity: qty }).then(function (j) { renderCart(j.sections); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var open = t.closest('[data-cart-open]');
    if (open && drawer && !onCartPage) { e.preventDefault(); openCart(); return; }
    if (t.closest('[data-cart-close]')) { closeCart(); return; }

    var qa = t.closest('[data-add-variant]');
    if (qa) {
      e.preventDefault();
      qa.classList.add('is-loading');
      var label = qa.textContent;
      addToCart({ id: parseInt(qa.getAttribute('data-add-variant'), 10), quantity: 1 })
        .catch(function (err) { qa.textContent = 'Unavailable'; setTimeout(function () { qa.textContent = label; }, 1800); })
        .then(function () { qa.classList.remove('is-loading'); });
      return;
    }

    var qc = t.closest('[data-qty-change]');
    if (qc) { changeLine(parseInt(qc.dataset.line, 10), parseInt(qc.dataset.qty, 10)); return; }

    /* header: menu + search */
    var menu = $('[data-menu]');
    if (t.closest('[data-menu-open]') && menu) { menu.hidden = false; document.body.classList.add('is-locked'); }
    if (t.closest('[data-menu-close]') && menu) { menu.hidden = true; document.body.classList.remove('is-locked'); }
    var st = t.closest('[data-search-toggle]');
    if (st) {
      var panel = $('[data-search-panel]');
      panel.hidden = !panel.hidden;
      st.setAttribute('aria-expanded', String(!panel.hidden));
      if (!panel.hidden) $('input', panel).focus();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCart();
      var menu = $('[data-menu]'); if (menu && !menu.hidden) { menu.hidden = true; document.body.classList.remove('is-locked'); }
    }
  });

  /* ---------- collection filters ---------- */
  var ff = $('[data-filter-form]');
  if (ff) ff.addEventListener('change', function () { ff.submit(); });

  /* ---------- product page ---------- */
  var pdp = $('[data-pdp]');
  if (pdp) {
    var variants = JSON.parse($('[data-variants]', pdp).textContent);
    var form = $('[data-product-form]', pdp);
    var idInput = $('[data-variant-id]', form);
    var atcBtns = [$('[data-atc]', form), $('[data-atc-sticky]', pdp)];
    var buyNow = $('[data-buy-now]', form);
    var errEl = $('[data-form-error]', form);
    var track = $('[data-gallery-track]', pdp);

    function selected() {
      return $$('.opt', form).map(function (fs) {
        var c = $('input:checked', fs); return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      return variants.filter(function (v) {
        return opts.every(function (o, i) { return v.options[i] === o; });
      })[0];
    }
    function scrollToMedia(id) {
      var item = $('[data-media-id="' + id + '"]', track);
      if (!item) return;
      track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      $$('.gallery__thumb', pdp).forEach(function (b) { b.classList.toggle('is-active', b.dataset.thumb == id); });
    }
    function updateUI(v) {
      $$('.opt', form).forEach(function (fs) {
        var c = $('input:checked', fs);
        var l = $('[data-option-label]', fs);
        if (c && l) l.textContent = c.value;
      });
      var priceEl = $('[data-price]', pdp), cmp = $('[data-compare]', pdp), disc = $('[data-discount]', pdp), sp = $('[data-price-sticky]', pdp);
      if (!v) {
        atcBtns.concat([buyNow]).forEach(function (b) { if (b) { b.disabled = true; } });
        atcBtns.forEach(function (b) { if (b) b.textContent = 'Unavailable'; });
        return;
      }
      idInput.value = v.id;
      priceEl.textContent = money(v.price);
      if (sp) sp.textContent = money(v.price);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      cmp.hidden = !onSale; disc.hidden = !onSale;
      if (onSale) { cmp.textContent = money(v.compare_at_price); disc.textContent = Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '% off'; }
      atcBtns.forEach(function (b) { if (b) { b.disabled = !v.available; b.textContent = v.available ? 'Add to cart' : 'Sold out'; } });
      if (buyNow) buyNow.disabled = !v.available;
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      if (v.featured_media) scrollToMedia(v.featured_media.id);
    }
    form.addEventListener('change', function (e) {
      if (e.target.type === 'radio') updateUI(findVariant(selected()));
    });

    /* qty steppers */
    $$('[data-qty-step]', form).forEach(function (b) {
      b.addEventListener('click', function () {
        var inp = $('input[name="quantity"]', form);
        inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10));
      });
    });

    /* ajax add to cart (Buy it now goes straight to checkout) */
    form.addEventListener('submit', function (e) {
      var sub = e.submitter;
      if (sub && sub.name === 'checkout') return;
      e.preventDefault();
      errEl.hidden = true;
      var qty = parseInt($('input[name="quantity"]', form).value, 10) || 1;
      var btns = atcBtns.filter(Boolean);
      btns.forEach(function (b) { b.disabled = true; });
      addToCart({ id: parseInt(idInput.value, 10), quantity: qty })
        .catch(function (err) { errEl.textContent = err.message; errEl.hidden = false; })
        .then(function () { updateUI(findVariant(selected())); });
    });
    /* sticky add-to-cart (mobile) */
    var sticky = $('[data-sticky-atc]', pdp), main = $('[data-atc]', form);
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sticky.hidden = en[0].isIntersecting || en[0].boundingClientRect.top > 0; }, { threshold: 0 }).observe(main);
    }
    /* thumbs */
    $$('[data-thumb]', pdp).forEach(function (b) { b.addEventListener('click', function () { scrollToMedia(b.dataset.thumb); }); });
    var firstThumb = $('.gallery__thumb', pdp); if (firstThumb) firstThumb.classList.add('is-active');
  }
})();
